import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=47030cfa&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"
import style0 from "./UserList.vue?vue&type=style&index=0&id=47030cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47030cfa",
  null
  
)

export default component.exports